import '../sass/service-header.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $serviceHeaders = document.querySelectorAll('.service-header');

    if (!$serviceHeaders) return;

    $serviceHeaders.forEach(($serviceHeader) => {
        const $imagesInner = $serviceHeader.querySelector('.service-header__images-inner');
        const $imagesCarousel = $serviceHeader.querySelector('.service-header__images-carousel');

        const imageCarouselResizer = new ResizeObserver(() => {
            calculateImageCarouselWidth();
        });

        const calculateImageCarouselWidth = () => {
            if (!$imagesInner || !$imagesCarousel) return;

            const radians = 20 * Math.PI / 180;
            const newWidth = $imagesInner.offsetHeight * Math.tan(radians);
            const calculatedWidth = $imagesInner.offsetWidth + newWidth;
            
            $imagesCarousel.style.width = `${calculatedWidth}px`;
        };

        const initCarousel = () => {
            if (!$imagesCarousel) return;

            new Swiper($imagesCarousel, {
                keyboard: {
                    enabled: true,
                },
                loop: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: false
                },
                autoplay: {
                    delay: 2000,
                },
                speed: noMotionPreference.matches ? 1000 : 0,
                allowTouchMove: false,
            });
        };

        // imageCarouselResizer.observe($imagesInner);

        initCarousel();
        // calculateImageCarouselWidth();
    });
})();
